var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',{staticClass:"card-header"},[_c('span',[_vm._v("设备状态分布")])])]},proxy:true}])},[_c('div',{ref:"chartRef",staticClass:"chart-canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }